<template>
  <div class="species">
    <div class="header">
      <div class="title">
        <h3>{{ speciesData.commonName }}</h3>
      </div>
      <p>{{ speciesData.name }}</p>
    </div>

    <div class="content">
      <div class="top">
        <div class="picture">
          <img :src="speciesData.picture.fields.file.url" alt="species image" />
        </div>

        <div class="details">
          <div class="section status">
            <div class="heading">
              <h4>Conservation status</h4>
              <div class="icon" @click="displayInformationPopup(true)">
                <div class="info-icon">
                  <p>i</p>
                </div>
              </div>
            </div>
            <div class="data status">
              <p>{{ speciesData.threatStatus }}</p>
            </div>
          </div>
          <div class="section">
            <div class="heading closable" @click="toggleAbout">
              <h4>About</h4>
              <i class="fa fa-angle-up" v-if="displayAbout"></i>
              <i class="fa fa-angle-down" v-if="!displayAbout"></i>
            </div>
            <div class="data" v-if="displayAbout">
              <p>{{ speciesData.about }}</p>
            </div>
          </div>
          <div class="section">
            <div
              class="heading closable"
              @click="displayFunFact = !displayFunFact"
            >
              <h4>Fun Fact</h4>
              <i class="fa fa-angle-up" v-if="displayFunFact"></i>
              <i class="fa fa-angle-down" v-if="!displayFunFact"></i>
            </div>
            <div class="data" v-if="displayFunFact">
              <p>{{ speciesData.fact }}</p>
            </div>
          </div>
          <div class="section" v-if="hasFirstNationsInfo">
            <div
              class="heading closable"
              @click="displayFirstNationsInfo = !displayFirstNationsInfo"
            >
              <h4>Further first nations information</h4>
              <i class="fa fa-angle-up" v-if="displayFirstNationsInfo"></i>
              <i class="fa fa-angle-down" v-if="!displayFirstNationsInfo"></i>
            </div>
            <div class="data" v-if="displayFirstNationsInfo">
              <p>{{ speciesData.languageExtraInfo }}</p>
            </div>
          </div>
          <div class="section">
            <div class="heading closable">
              <h4>Key threats</h4>
            </div>
            <div class="threats">
              <div
                class="threat"
                v-for="threat of speciesData.threats"
                :key="threat.fields.name"
              >
                <div class="threat-icon">
                  <img
                    :src="threat.fields.icon.fields.file.url"
                    :alt="threat.name"
                  />
                </div>
                <div class="threat-name">
                  <p class="uppercase">{{ threat.fields.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom" v-if="displayExtinct">
        <div class="content">
          <div
            class="warning-icon"
            style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/warning.png')"
          ></div>
          <p class="uppercase">
            There has been an extinction event in your area in the last 10
            years.
          </p>
          <div class="icon" @click="displayInformationPopup(false)">
            <div class="info-icon light">
              <p>i</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSpecies",
  data() {
    return {
      // Species details toggles
      displayAbout: false,
      displayFunFact: false,
      displayFirstNationsInfo: false,
      hasFirstNationsInfo: false,
    };
  },
  computed: {
    speciesData() {
      return this.$store.getters.speciesData;
    },
    displayExtinct() {
      return this.$store.getters.numExtinct > 0;
    },
  },

  watch: {
    speciesData(newValue) {
      if (newValue.languageTerm) {
        newValue.commonName = `${newValue.commonName} - ${newValue.languageTerm} / ${newValue.languageGroup}`;

        if (newValue.languageExtraInfo) this.hasFirstNationsInfo = true;
        else this.hasFirstNationsInfo = false;
      } else this.hasFirstNationsInfo = false;

      this.displayAbout = false;
      this.displayFunFact = false;
      this.displayFirstNationsInfo = false;
    },
  },

  mounted() {
    if (this.speciesData.name !== "") {
      if (this.speciesData.languageTerm) {
        this.speciesData.commonName = `${this.speciesData.commonName} - ${this.speciesData.languageTerm} / ${this.speciesData.languageGroup}`;

        if (this.speciesData.languageExtraInfo) this.hasFirstNationsInfo = true;
        else this.hasFirstNationsInfo = false;
      } else this.hasFirstNationsInfo = false;
    }
  },

  methods: {
    toggleAbout() {
      this.displayAbout = !this.displayAbout;
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Species Detail Concertina",
        eventProperties: { Click: true },
      });
    },

    displayInformationPopup(conservationStatus) {
      if (conservationStatus) {
        this.$store.commit("updatePopupTitle", "What is conservation status?");
        this.$store.commit(
          "updatePopupDescription",
          "Many factors are used to assess the conservation status of an animal or plant. Under the EPBC Act, the status indicates its risk of extinction via one of the following categories: ‘Conservation Dependent’,  ‘Vulnerable’, ‘Endangered’, ‘Critically Endangered’, ‘Extinct in Wild’ and ‘Extinct’."
        );
      } else {
        this.$store.commit("updatePopupTitle", "Extinction Event");
        this.$store.commit(
          "updatePopupDescription",
          "In the past 10 years, an animal or plant has become extinct and no longer exists in the area. This may be a complete extinction, where the species no longer exists anywhere in the world, or it could be extinction in the wild, where they no longer exist in their natural habitat."
        );
      }

      this.$store.commit("updateOpenModal", false);
      this.$store.commit("updateOpenInformationPopup", true);
      document.getElementById("ra-header").scrollIntoView({
        behavior: "smooth",
        block: "end",
      });

      // Log info popup
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Info Pop Up",
        eventProperties: {
          "Related Content Text": conservationStatus
            ? "Conservation Status"
            : "Extinction Event",
        },
      });
    },
  },
};
</script>

<style scoped>
h3 {
  padding: 0;
  margin: 0;
}

h3:before {
  background-color: transparent;
}

.info-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid #323232;
  border-radius: 100%;
  padding: 4px;
  width: 24px;
  height: 24px;
}

.info-icon.light {
  border-color: var(--white);
}

.species {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
  width: 100%;
  padding: 0 64px;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.header .title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.top {
  display: flex;
  gap: 24px;
  width: 100%;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  border-top: 1px solid #dadada;
  padding-top: 12px;
}

.section .heading {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.section .heading.closable {
  justify-content: space-between;
  cursor: pointer;
}

.icon {
  cursor: pointer;
}

.section h4 {
  font-size: 24px;
  color: #1e1e1e;
  margin: 0px;
  text-transform: uppercase;
}

.picture {
  width: 700px;
  height: 700px;
}

.picture img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.section .data {
  display: flex;
  align-items: center;
}

.section.status {
  flex-direction: row;
  justify-content: space-between;
  border-top: none;
}

.section.status .heading {
  display: flex;
  gap: 8px;
}

.details .data.status {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.023em;
  color: #1e1e1e;
}

.threats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.threat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 150px;
}

.threat .threat-icon {
  width: 64px;
  height: 64px;
}

.threat .threat-name {
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  text-align: center;
  color: #212121;
}

.bottom {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 100px;
  padding: 12px;
  background-color: var(--black);
}

.bottom .content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 100px;
  background-color: var(--black);
}

.bottom p {
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
}

.bottom .warning-icon {
  width: 64px;
  height: 64px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

@media only screen and (max-width: 1000px) {
  .top {
    flex-direction: column;
  }

  .top .picture {
    width: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .top .picture {
    height: 600px;
  }
}

@media only screen and (max-width: 650px) {
  .bottom .warning-icon {
    width: 74px;
  }
}

@media only screen and (max-width: 600px) {
  .top .picture {
    height: 500px;
  }

  .section.status {
    flex-direction: column;
    justify-content: center;
    gap: 0px;
  }

  .section.status .heading {
    justify-content: space-between;
    gap: 0;
  }

  .bottom {
    padding: 0 12px;
  }
}

@media only screen and (max-width: 560px) {
  .species {
    padding: 0 24px;
  }

  .bottom {
    gap: 8px;
  }

  .bottom .icon {
    display: flex;
    align-items: flex-start;
    height: 100%;
    padding-top: 10px;
  }

  .bottom .content {
    gap: 8px;
  }

  .bottom .warning-icon {
    width: 70px;
  }
}

@media only screen and (max-width: 480px) {
  .bottom .warning-icon {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// HeroSpecies.vue?360de795